import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SURVEY_APP_URL } from "@/data/links";

export default function SurveyRedirect() {
  const { pathname, search } = useLocation();
  const target = `${SURVEY_APP_URL}${pathname.replace(/^\/survey/, "")}${search}`;

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <div data-testid="survey-redirect" className="min-h-screen flex flex-col items-center justify-center bg-parchment-100 text-center px-6">
      <div className="w-10 h-10 border-2 border-cocoa-900/20 border-t-terracotta rounded-full animate-spin" />
      <h1 className="mt-6 font-serif text-2xl text-cocoa-900">Opening the Parish Family Survey…</h1>
      <a href={target} data-testid="survey-redirect-link" className="mt-4 text-sm text-terracotta underline font-sans">
        Tap here if it doesn't open
      </a>
    </div>
  );
}
